// extracted by mini-css-extract-plugin
export default {"container":"Master_container__PRT1G","spinnerContainer":"Master_spinnerContainer__QN32z"};